import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { showErrorToast, showSuccessToast } from "../utils/Toasts";
import { updateUserData, logoutUser } from "../redux/slice/userSlice";
import { useDispatch } from "react-redux";
import { registerBiometricCredential, detectFeatures, isWebAuthnAvailable } from "../utils/biometricUtils";
import { VerifyLogin } from "../service/SpatApi";
import { requestForToken } from '../messaging/firebaseMessaging'

export function useAuth() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  async function authenticateUser(token) {
    setLoading(true);
    dispatch(logoutUser()); // Reset state before fresh login
    const {
      platform,
      source,
      location
    } = await detectFeatures(true);
    const deviceNotificationRegistration = await requestForToken();
    try {
      const reponseVerifyLogin = await VerifyLogin(token, JSON.stringify({
        deviceInfo: {
          platform,
          source,
          location
        },
        newLoginIn: true,
        deviceNotificationRegistration
      })
      );
      if (!reponseVerifyLogin) {
        throw new Error("Token Reauth Failed");
      }
      // ✅ Redux update
      dispatch(updateUserData({
        firstName: reponseVerifyLogin.user.firstName,
        email: reponseVerifyLogin.user.email,
        roles: reponseVerifyLogin.user.roles,
        isLoggedIn: true,
        // mobileVerification: data.user.mobileVerification
      }));
      const isBiometricAvailable = await isWebAuthnAvailable();
      // Biometric support check
      if (isBiometricAvailable) {
        try {
          await registerBiometricCredential(reponseVerifyLogin.user.email);
        } catch (err) {
          console.error("Error during biometric support check:", err.message);
        }
      }
      else {
        console.warn("Biometric authenticator not available or configured.");
      }
      showSuccessToast(reponseVerifyLogin?.message || "வெற்றிகரமாக உள்நுழைந்தீர்கள்");
      setTimeout(() => {
        let redirectTo = localStorage.getItem('postLoginRedirect') || '/user/profile';
        const isAuthRoute = redirectTo.startsWith("/auth") || redirectTo.startsWith("/register");
        if (isAuthRoute) {
          redirectTo = '/user/profile'
        }
        localStorage.removeItem('postLoginRedirect');
        navigate(redirectTo, { replace: true });
      }, 1000);
    } catch (error) {
      showErrorToast(error.message || "சரிபார்ப்பு தோல்வியடைந்தது");
    } finally {
      setLoading(false);
    }
  }
  return {
    authenticateUser,
    loading,
  };
}
